export enum LoggedOutGeneratorSection {
  ScanDestination = 'scan-destination',
  CodeDesign = 'code-design',
  ColorSelector = 'color-selector',
  ShapeSelector = 'shape-selector',
  FrameAndText = 'frame-and-text',
  Logo = 'logo',
  SignUp = 'sign-up'
}
